import moment from 'moment'

export const IS_PROD = process.env.NODE_ENV === 'production'
export const IS_STAGING = process.env.NODE_ENV === 'staging'
export const IS_DEV =
  process.env.NODE_ENV === 'dev' ||
  process.env.NODE_ENV === 'development' ||
  process.env.NODE_ENV == null

export const ROOM_HOLD_DURATION = moment
  .duration(20, 'minutes')
  .as('milliseconds')
export const ROOM_EXTEND_DURATION = moment
  .duration(19, 'minutes')
  .as('milliseconds')
// Give a little extra time on the server before releasing rooms
export const ROOM_HOLD_DURATION_SERVER = moment
  .duration(21, 'minutes')
  .as('milliseconds')
export const RELEASE_ROOMS_DURATION_SERVER = moment
  .duration(21, 'minutes')
  .as('milliseconds')
export const HOLD_CLEANUP_INTERVAL = moment
  .duration(ROOM_HOLD_DURATION_SERVER, 'milliseconds')
  .add(10, 'seconds')
  .as('milliseconds')
export const MAX_SF_REQUEST = 30 // Max number of concurrent requests by salesforce

export const pricePanelFields = ['useCustomAmount', 'customAmount', 'comment']
export const hiddenFields = ['howDidYouHear'] // Configure the fields which needs to be hidden in guest entry page

export const DATE_STANDARD_FORMAT = 'MM/DD/YYYY h:mm:ss A'
export const CST_TIME_ZONE = process.env.TZ ? process.env.TZ : 'America/Chicago'
export const STATE_ELIGIBLE_GUESTENTRY = [
  'SELECT_COMPLETED',
  'GE_PROCESSING',
  'GE_COMPLETED'
]

export const DISQUALIFYING_CONTACT_FLAGS = ['red', 'orange', 'yellow', 'black']

export const FLAGGED_CONTACT_OFFICE_TEAM_TEXT = 'This contact has been flagged '

export const FLAGGED_CONTACT_CS_TEAM_TEXT =
  'Please inform the caller that their reservation cannot be processed at this time, a volunteer from iii welcome center in Tennessee will reach out to them shortly. Take their name and number and inform iii office to help process this stay request.'

export const FLAGGED_CONTACT_GUEST_BOOKING_TEXT =
  'Your request cannot be processed at this time, please call 931 668 1900 for help.'



// WEBPACK FOOTER //
// ./src/constants.js